import styled from 'styled-components';
import { font, spacing } from '@chegg-ui/theme';
import { NotificationBanner } from '@chegg-ui/notification-banner';
import { Link } from '@chegg-ui/link';
export var Container = styled.div.withConfig({
  componentId: "sc-1w81iwp-0"
})(["margin-top:", ";#no_chegg_account{margin-top:0.875rem;}"], function (props) {
  return props.noMargin ? 0 : spacing.px16;
});
export var ErrorMessage = styled.div.withConfig({
  componentId: "sc-1w81iwp-1"
})(["padding-top:", ";line-height:1.5;"], spacing.px4);
export var ErrorBanner = styled(NotificationBanner).withConfig({
  componentId: "sc-1w81iwp-2"
})(["width:auto;div:first-child{align-items:center;}"]);
export var SuccessBanner = styled(NotificationBanner).withConfig({
  componentId: "sc-1w81iwp-3"
})(["width:auto;div:first-child{align-items:center;}"]);
export var CtaLink = styled(Link).withConfig({
  componentId: "sc-1w81iwp-4"
})(["cursor:pointer;font-size:", ";"], font.size.px14);